import req from "@/utils/axios.js";

export default {
    // 获取活动列表
    getActivityList(data) {
        return req.get("/wxShop/signEvent/list", {
            ...data
        })
    },

    // 获取活动详情
    getActivityDetail(data) {
        return req.get("/wxShop/signEvent/info", {
            ...data
        })
    },
    // 获取活动数据
    getActivityData(data) {
        return req.get("/wxShop/signEvent/data", {
            ...data
        })
    },
    // 导出活动数据
    exportActivityData(data) {
        return req.post("/wxShop/signEvent/dataExport", {
            ...data
        })
    },

    // 创建活动
    createActivity(data) {
        return req.post("/wxShop/signEvent/create", {
            ...data
        })
    },

    // 开始活动
    startActivity(data) {
        return req.post("/wxShop/signEvent/start", {
            ...data
        })
    },

    // 结束活动
    endActivity(data) {
        return req.post("/wxShop/signEvent/end", {
            ...data
        })
    },

    // 取消活动
    cancelActivity(data) {
        return req.post("/wxShop/signEvent/cancel", {
            ...data
        })
    },

    // 删除活动
    deleteActivity(data) {
        return req.post("/wxShop/signEvent/delete", {
            ...data
        })
    },

    // 活动签到
    signActivity(data) {
        return req.post("/wxShop/signEvent/sign", {
            ...data
        })
    }
}
